'use strict';

import SyncError from '../../errors';

const noop = () => {};

export default (superclass) => class extends superclass {
    /**
     * _successCallback - Wrapper for the real success callback so we can
     *  promisify it
     *
     * @param  {function} callback the original callback
     * @param  {object} options A backbone style options object
     * @param  {function} resolver A promise resolver function
     * @return {function}
     */
    _successCallback(callback, options, resolver) {
        return (xhr, status, error) => {
            resolver(this, xhr, status, error);
            callback.call(this, xhr, status, error);
        };
    }

    /**
     * _errorCallback - Wrapper for the real error callback so we can
     *  promisify it
     *
     * @param  {function} callback the original callback
     * @param  {object} options A backbone style options object
     * @param  {function} rejecter A promise rejecter function
     * @return {function}
     */
    _errorCallback(callback, options, rejecter) {
        return (xhr, status, error) => {
            callback.call(this, xhr, status, error);
            rejecter(new SyncError(
                this,
                xhr.responseJSON || xhr.responseText,
                options
            ));
        };
    }

    /**
     * sync - An overriden sync method that returns a promise
     *
     * @param  {string} method The method used to sync agains the server
     * @param  {external:Backbone.Model} model A model
     * @param  {object} options A backbone style options object
     * @return {external:Promise} A promise that will be resolved or rejected
     *  depending on what the server replies
     */
    sync(method, model, options) {
        let success = options.success || noop;
        let error = options.error || noop;
        return new Promise((resolve, reject) => {
            options.success = this._successCallback(success, options, resolve);
            options.error = this._errorCallback(error, options, reject);
            super.sync(method, model, options);
        });
    }

    /**
     * save - An overriden save method that *always* returns a promise. The
     * emphasis on always is because if the model validation fails, backbone
     * returns false by default instead of calling the error callback.
     *
     * @return {external:Promise}
     */
    save() {
        const r = super.save(...arguments);
        if (r === false) {
            return Promise.reject(this.validationError);
        }
        return r;
    }
};




// WEBPACK FOOTER //
// ./app/new-models/mixins/promisify-sync.js